import { WizardNumericInput } from 'common/components/WizardControls/WizardNumericInput';
import { FC } from 'react';
import { CenteredText } from './styles';

export type RateFormProps = {
  /** The dynamic key that `useForm` will map with. */
  formValueKey: string;
  /** The display value of the rate cost. It is not used in edit mode. */
  displayValue: string;
};

export const TableRateInput: FC<{
  showInput: boolean;
  value: RateFormProps;
  isSubmitting: boolean;
}> = ({ showInput, value, isSubmitting }) =>
  showInput ? (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <WizardNumericInput
        maxWidth='100px'
        maxHeight='22px'
        name={value.formValueKey}
        isDisabled={isSubmitting}
      />
    </div>
  ) : (
    <CenteredText>{value.displayValue}</CenteredText>
  );
